/* Scentlegacy · Storm: the sky video, lightning now and then, and the mood menu. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const RM = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- the sky: fade the video in once it plays, hold still for reduced motion ---------- */
  const storm = $('.storm');
  const video = storm && $('.storm-video', storm);
  if (video) {
    const apply = () => { if (RM.matches || document.hidden) video.pause(); else video.play().catch(() => {}); };
    video.addEventListener('playing', () => storm.classList.add('live'), { once: true });
    RM.addEventListener('change', apply);
    document.addEventListener('visibilitychange', apply);
    apply();
  }

  /* ---------- lightning: a jagged bolt and a flash, every 7 to 16 seconds ---------- */
  const bolts = storm && $('.storm-bolts', storm);
  const flash = storm && $('.storm-flash', storm);
  const NS = 'http://www.w3.org/2000/svg';
  const jag = (x, y, len, spread) => {
    let d = `M${x.toFixed(1)} ${y.toFixed(1)}`;
    const steps = 9 + Math.floor(Math.random() * 5);
    for (let i = 1; i <= steps; i++) {
      x += (Math.random() - 0.5) * spread;
      y += len / steps;
      d += ` L${x.toFixed(1)} ${y.toFixed(1)}`;
    }
    return { d, x, y };
  };
  const strike = () => {
    if (!bolts || RM.matches || document.hidden) return;
    const w = innerWidth, h = innerHeight;
    const x0 = w * (0.12 + Math.random() * 0.76);
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
    svg.setAttribute('preserveAspectRatio', 'none');
    const main = jag(x0, -10, h * (0.45 + Math.random() * 0.25), 70);
    const paths = [[main.d, 2.4]];
    if (Math.random() < 0.7) {
      const by = h * (0.12 + Math.random() * 0.2);
      paths.push([jag(x0 + (Math.random() - 0.5) * 60, by, h * 0.22, 46).d, 1.2]);
    }
    paths.forEach(([d, wdt]) => {
      const p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      p.setAttribute('stroke-width', wdt);
      svg.appendChild(p);
    });
    bolts.appendChild(svg);
    flash.style.setProperty('--fx', (x0 / w * 100).toFixed(1) + '%');
    flash.classList.remove('on'); void flash.offsetWidth; flash.classList.add('on');
    setTimeout(() => svg.remove(), 1100);
  };
  const loop = () => { setTimeout(() => { strike(); loop(); }, 7000 + Math.random() * 9000); };
  if (bolts) { setTimeout(strike, 2200); loop(); }

  /* ---------- the mood menu: filters the floating shop in place, or links home ---------- */
  const items = $$('.float');
  const links = $$('[data-filter]');
  const empty = $('.shop-empty');
  const known = new Set(['all', ...links.map(a => a.dataset.filter)]);
  const show = f => {
    links.forEach(a => a.classList.toggle('is-on', a.dataset.filter === f));
    let n = 0;
    items.forEach(it => {
      const on = f === 'all' || (it.dataset.moods || '').split(' ').includes(f);
      it.classList.remove('pop');
      it.hidden = !on;
      if (on) { n++; void it.offsetWidth; it.classList.add('pop'); }
    });
    if (empty) empty.hidden = n > 0;
  };
  if (items.length) {
    links.forEach(a => a.addEventListener('click', e => {
      e.preventDefault();
      const f = a.dataset.filter;
      show(f);
      history.replaceState(null, '', f === 'all' ? location.pathname : `${location.pathname}?mood=${f}`);
      const grid = $('#collection');
      if (grid && grid.getBoundingClientRect().top > innerHeight * 0.6) grid.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth' });
    }));
    const m = new URLSearchParams(location.search).get('mood');
    show(m && known.has(m) ? m : 'all');
  }
})();
